import { Box, CircularProgress } from '@mui/material';
import React from 'react';

function Loader() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                py: 3,
            }}
        >
            <CircularProgress />
        </Box>
    );
}

export default Loader;
